import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const CartIcon = ({ color }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="16px"
			viewBox="0 0 12 12"
			fill="none"
		>
			<path
				d="M4.51676 10.8022C4.74688 10.8022 4.93343 10.597 4.93343 10.3438C4.93343 10.0907 4.74688 9.8855 4.51676 9.8855C4.28665 9.8855 4.1001 10.0907 4.1001 10.3438C4.1001 10.597 4.28665 10.8022 4.51676 10.8022Z"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.10026 10.8022C9.33038 10.8022 9.51693 10.597 9.51693 10.3438C9.51693 10.0907 9.33038 9.8855 9.10026 9.8855C8.87014 9.8855 8.68359 10.0907 8.68359 10.3438C8.68359 10.597 8.87014 10.8022 9.10026 10.8022Z"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.18359 1.17725H2.85026L3.96693 7.31433C4.00503 7.52534 4.10939 7.7149 4.26174 7.8498C4.41409 7.98471 4.60472 8.05637 4.80026 8.05225H8.85026C9.0458 8.05637 9.23643 7.98471 9.38878 7.8498C9.54113 7.7149 9.64549 7.52534 9.68359 7.31433L10.3503 3.46891H3.26693"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
